import $axios from "../../../../api/accessories";
import { $api } from "../../../../api/api";

interface ProfileData {
  name: string;
  surname: string;
  email: string;
  number: string;
  address: string;
  fin: string;
  gender?: string;
  password?: string;
  new_password?: string;
  confirm_password?: string;
  number_prefix: number;
  branch_id?: number | string | null;
}

export class ProfileProvider {
  static async getProfileData() {
    return await $axios.get($api("get_profile_data"));
  }

  static async updateProfile(data: ProfileData) {
    return await $axios.post($api("update_profile_data"), data);
  }
}
